/**
 * Collection representing questions  
 * @class
 */
Selector.Collection.QuestionList = Backbone.Collection.extend(
/** @lends Selector.Collection.QuestionList# */
{
	/** the model this collection will use */
	model: Selector.Model.Question,

    /* selector type */
    key: null,

    groups: false,
    groupActive: 1,

    resultModel: null, //holds our results

	parse: function(results) {

        var _this = this;

		$.each(results, function(j, response) {

            response.IDNUM = parseInt(response.ID.replace("question_", ""));

            if (response.GROUP != "") {
                _this.groups = true;
            }
			
			//fucking Coldfusion JSON turns Yes/No into true/false
			var len = response.ANSWERS.length;
			for (var i = 0; i < len; i++) {
                if (response.ANSWERS[i].VALUE === true) { response.ANSWERS[i].VALUE = "Yes"; }
                if (response.ANSWERS[i].VALUE === false) { response.ANSWERS[i].VALUE = "No"; }
                if (response.ANSWERS[i].LABEL === true) { response.ANSWERS[i].LABEL = "Yes"; }
                if (response.ANSWERS[i].LABEL === false) { response.ANSWERS[i].LABEL = "No"; }
			}
			
		});
		
		return results;
	},

    activateQuestion: function(model) {
        this.each(function(model){
            model.set({"ACTIVE": false}, {silent: true});
        }, this);
        model.set({"ACTIVE": true});
    },

	parseAnswers: function() {

		var _this = this,
            end = false,
			count = 0, //if the while loop goes over the number of questions then something has gone wrong, so break 
			activeQuestion = this.models[0];

        //is this group driven? Work out which group we should be on.
        if (this.groups) {

            var breakThis = false,
                groupCount = 1;

            while (!breakThis) {
                var unanswered = this.filter(function(model){
                    return model.get("GROUP") == groupCount && (model.get("ANSWER") === null || model.get("ANSWER") === "");
                });

                if (unanswered.length > 0 || groupCount  > ele.selector.data.GROUPS.length) {
                    _this.groupActive = groupCount;
                    breakThis = true;
                }

                groupCount++;

            }
        }

		while (!end && count < this.length) {
			try {
				if (activeQuestion.get("ANSWER")){
					//question is answered, get next question
                    var answerText = activeQuestion.get("ANSWER").split("|").pop();

					var answer = _.find(activeQuestion.get("ANSWERS"), function (obj) { return obj.VALUE === answerText; }),
                        destination = answer.DESTINATION,
                        evm = answer.EVM,
                        warning = answer.WARNING;

                    activeQuestion.set("EVM", "");
                    if (evm !== "") {
                        activeQuestion.set({"EVM": answer.EVM}, {silent: true});
                    }
                    activeQuestion.set("WARNING", "");
                    if (warning !== "") {
                        activeQuestion.set("WARNING", _.find(ele.selector.data.WARNINGS, function(obj) { return obj.ID === warning; }).CONTENT);
                    }
					if (destination === "result" || (this.groups && this.groupActive > ele.selector.data.GROUPS.length)) {
						if (ele.selector.data.CONFIG.SELECTORBEHAVIOUR !== "FLAT"){ activeQuestion.set({"ACTIVE": false, "CURRENT": false}); }
						this.calculateResult();
						end = true;
					} else if (destination) {
						if (ele.selector.data.CONFIG.SELECTORBEHAVIOUR !== "FLAT") { activeQuestion.set({"ACTIVE": false, "CURRENT": false}); }
						activeQuestion = _.find(this.models, function(obj) { return obj.get("ID") === destination; });
						activeQuestion.set({"ACTIVE": true, "CURRENT": true});
						this.resultModel.set("results", []);
					}
				} else {
					end = true;
				}
			} catch (e) {
				console.log( "couldn't find something for reasons");
				console.log(e);
				end = true;
			}
			
			count++;
		}
		this.saveState();
		
	},

	calculateResult: function(){

        //clone result pool
        var resultPool = ele.selector.data.RESULTS.slice(0);

        //parse each answer, throwing out results that don't match our user's choices
        this.each(function(model){

            var answer = model.get("IDNUM") + ":" + model.get("ANSWER"),
                unAnswered = false;

            if (model.get("ANSWER") === null || ele.selector.answerbehaviour === "allowChange" && !model.get("ACTIVE")) {
                answer = model.get("IDNUM") + ":"; unAnswered = true;
            }

            var rLength = resultPool.length;
            for (var j = 0; j < rLength; j++) {

                //if there is a question and this question is visible
                if (resultPool[j]) {
                    //if the method DOESN'T contain our answer but DOES contain another answer for this question - remove it from the potential results

                    //method as a string does not work. Split to array
                    var methodArray = resultPool[j].METHOD.split(","),
                        answerNumber = answer.split(":")[0],
                        answerText = answer.split(":")[1];

                    if ((this.arrayFind(answer, methodArray) === -1 && this.arrayFind((answerNumber+":"), methodArray) > -1)) {
                        //the answer required for this result isn't in the list of customer answers, AND there's another answer for this question
                        //console.log("1removing "+resultPool[j].METHOD);
                        resultPool[j] = undefined;
                    } else if (this.arrayFind(answerNumber + ":", methodArray) > -1 && unAnswered) {
                        //else if the method requires an answer but we haven't given one, remove
                        //console.log("2removing "+resultPool[j].METHOD);
                        resultPool[j] = undefined;
                    } else {
                        //console.log("leaving "+resultPool[j].METHOD);
                    }
                }
            }

        }, this);

        //all this bit does is remove holes in the array
        var resultList = [],
            rLength = resultPool.length;
        for (var j = 0; j < rLength; j++) {
            //is there an item in this array slot
            if (resultPool[j] !== undefined) {
                //has this item already been put into the array?
                if (resultList.filter(function(el){return el.CONTENT === resultPool[j].CONTENT;}).length === 0) {
                    resultList.push(resultPool[j]);
                }
            }
        }

        //if a healthcheck, show multiple results. Otherwise show first.
        if (ele.selector.data.CONFIG.SELECTORTYPE.toLowerCase().indexOf("healthcheck") > -1) {
            this.resultModel.set("results", resultList);
        } else {
            this.resultModel.set("results", [resultList.shift()]);
        }

        if(this.resultModel.get('results').length){
            this.resultModel.set("NoRelevantResultsBasedOnAnswers", false);
            this.resultModel.fetchProduct();
        } else {
            this.resultModel.set("NoRelevantResultsBasedOnAnswers", true);
        }

        this.saveResult();
        this.saveEVMs();
    },

    resetAnswers: function(){
        this.groupActive = 1;
        this.each(function(model){
            model.resetModel();
        }, this);
        this.models[0].set("ACTIVE", true);
        this.resultModel.set({results: null, NoRelevantResultsBasedOnAnswers: false});
        this.resultModel.trigger('change'); // Because in some contexts the set does not trigger a change (correctly)
    },

    /**
     * use local storage to load and save the state of this question list
     */
    saveState: function() {
        var myAnswers = [];
        this.each(function(model) {
            if (model.get("ANSWER") !== null ){
                myAnswers.push(model.get("IDNUM") + ":" + model.get("ANSWER"));
            }
        });

        if(typeof(Storage)!=="undefined") {
            localStorage.setItem(this.key, JSON.stringify(myAnswers));
        }
    },

    loadState: function(){
        if (typeof(Storage)!=="undefined") {
            var myAnswers = JSON.parse(localStorage.getItem(this.key));
            if (myAnswers) {
                for (var i = 0; i < myAnswers.length; i++) {
                    if (myAnswers[i] !== null) {
                        var splitAnswer = myAnswers[i].split(":");
                        if (splitAnswer.length > 1) {
                            var key = parseInt(myAnswers[i].split(":")[0]);
                            var answer = myAnswers[i].split(":")[1];
                            this.find(function (model) {
                                return model.get("IDNUM") === key;
                            }).set({"ANSWER": answer}, {silent:true});
                        }
                    }
                }
            }
            this.parseAnswers();
        }
    },

    resetState: function(){
        //remove items from local storage
        localStorage.removeItem(this.key);
    },


    /**
     * save the result set in database (for reporting)
     * and save EVMs to personData
     */

    saveResult: function() {
        if (this.save === true && ele.config.usersession.id !== 0 && ele.selector.data.CONFIG.SAVE) {

            var _this = this,
                friendlyAnswers = {},
                formData = new FormData();

            this.each(function(model) {
                if (model.get("ANSWER") !== null ){
                    friendlyAnswers[model.get("TITLE")] = model.get("ANSWER");
                }
            });

            formData.append("ajax", "1");
            formData.append("persondatatype", "selector");
            formData.append("persondatakeyname", _this.key);
            formData.append("persondatageneric", _this.key);
            formData.append("persondatastring", JSON.stringify(friendlyAnswers));

            fetch(ele.uri.buildUrl("personData"), {
                body: formData,
                credentials: "same-origin",
                method: 'POST'
            })
            .then(function(response) {
                return response.json();
            })
            .catch(function(error){
                console.error(error);
            });

            this.save = false;
        }
    },

    /**
     * we can't save this server side because of GDPR. Save in session data. Pray we can reach
     * this on the server
     */

    saveEVMs: function() {

        if (ele.selector.data.CONFIG.SAVEEVMS) {

            var _this = this,
                evms = {};

            this.each(function(model) {
                if (model.get("EVM") !== undefined && model.get("EVM") !== null){
                    var evm = model.get("EVM").split(":");
                    if (evm.length === 2 && evm[0] != "" && evm[1] != "") {
                        evms[evm[0]] = evm[1];
                    }
                }
            });

            ele.cookieWarning.setCookie("evms", JSON.stringify(evms));

            this.save = false;
        }
    },

    //utilities

    //my special arrayFind() that matches substring but ensures 3: is not found in 13:
    arrayFind: function(obj, arr) {

        for (var i = 0, j = arr.length; i < j; i++) {

            //multi-answer questions(healthcheck)
            if (obj.indexOf("|") > -1 && //this is a multi question answer
                obj.indexOf(arr[i].split(":")[1]) > -1 && //the required answer is in this answer
                arr[i].indexOf(obj.split(":")[0]) === 0 //the question number is in this answer
            ) return i;

            //normal questions
            if (arr[i].indexOf(obj) === 0) return i;

        }

        return -1;
    }

});